'use strict';

export function dyanne_platformToggleInstocknotifierForm(element, mode) {

    const variationField = element.closest('form').querySelector('.variation_id');
    const subscriberField = element.closest('form').parentNode.querySelector('[name="notifier_product_id"]');
    const notifierForm = element.closest('form').parentNode.querySelector('.notifier-form-wrapper');
    
    if ( ! variationField || ! subscriberField ) {
        return;
    }

    // Set product ID to the notifier form.
    Alpine.$data(notifierForm).variationId = variationField.value;

    // Show or hide the form.
    Alpine.$data(notifierForm).showNotifierForm = ('show' === mode) ? true : false;
}

export function dyanne_platformSubscribeInstocknotifier(element) {

    const subscribeData = new FormData(element);
    subscribeData.append('action', 'dyanne_platform_subscribe_instocknotifier');

    const submitButton = element.querySelector('[type="submit"]');
    Alpine.$data(submitButton).processingNotifierForm = true;

    fetch(dyanne_platform_xhr.ajaxurl, {
        method: 'POST',
        body: subscribeData,
    })
        .then(response => response.json())
        .then(data => {
            if (true !== data.success) {
                Modal.alert(data.data.message, { top: (window.innerHeight * 0.5) });
            }

            submitButton.classList.remove('btn-loading');
            submitButton.classList.add('btn-done');
            submitButton.classList.remove('opacity-50');
            submitButton.textContent = submitButton.getAttribute('data-confirmation');

            setTimeout(
                function () {
                    submitButton.classList.remove('btn-done');
                    submitButton.disabled = false;
                    submitButton.textContent = submitButton.getAttribute('data-label');

                    element.reset();
                },
                1500
            );
        })
        .catch((error) => {
            console.error('Error:', error);
        });
}